export default __webpack_public_path__ + "static/media/theChief.9bbf58fd.png";